/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { BusinessType } from './BusinessType';
import {
    BusinessTypeFromJSON,
    BusinessTypeFromJSONTyped,
    BusinessTypeToJSON,
    BusinessTypeToJSONTyped,
} from './BusinessType';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { BusinessLabel } from './BusinessLabel';
import {
    BusinessLabelFromJSON,
    BusinessLabelFromJSONTyped,
    BusinessLabelToJSON,
    BusinessLabelToJSONTyped,
} from './BusinessLabel';

import { type Merchant, MerchantFromJSONTyped, MerchantToJSON, MerchantToJSONTyped } from './Merchant';
/**
 * Represents a single business entity.
 * @export
 * @interface Business
 */
export interface Business {
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Business
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Business
     */
    updatedAt: number;
    /**
     * 
     * @type {BusinessType}
     * @memberof Business
     */
    type: BusinessType;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    internalName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Business
     */
    taxonomies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Business
     */
    brands?: Array<string>;
    /**
     * 
     * @type {Array<BusinessLabel>}
     * @memberof Business
     */
    labels?: Array<BusinessLabel>;
    /**
     * 
     * @type {Asset}
     * @memberof Business
     */
    icon?: Asset;
    /**
     * 
     * @type {Asset}
     * @memberof Business
     */
    headerImage?: Asset;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    stripeAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    description?: string;
    /**
     * 
     * @type {Address}
     * @memberof Business
     */
    address: Address;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    email?: string;
    /**
     * Distance between origin and destination in KM.
     * @type {number}
     * @memberof Business
     */
    distance?: number;
    /**
     * Control allowing merchants to permanently close the business. If false, do not show location to customers or merchants.
     * @type {boolean}
     * @memberof Business
     */
    isEnabled?: boolean;
    /**
     * Control allowing admins to permanently close the business. If true, do not show location to customers or merchants.
     * @type {boolean}
     * @memberof Business
     */
    isArchived?: boolean;
    /**
     * Control allowing merchants to temporarily close the business until the specified time.
     * @type {number}
     * @memberof Business
     */
    suspendUntil?: number;
    /**
     * Control allowing admins to disable the business. If false, do not show location to customers or merchants.
     * @type {boolean}
     * @memberof Business
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    websiteMobile?: string;
    /**
     * Extension to the URL on the DevourGO webpage.
     * @type {string}
     * @memberof Business
     */
    url: string;
    /**
     * See moment.tz.names()
     * @type {string}
     * @memberof Business
     */
    timeZone: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof Business
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {number}
     * @memberof Business
     */
    marketplacePercentageDelivery?: number;
    /**
     * 
     * @type {number}
     * @memberof Business
     */
    marketplacePercentagePickup?: number;
}



/**
 * Check if a given object implements the Business interface.
 */
export function instanceOfBusiness(value: object): value is Business {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    return true;
}

export function BusinessFromJSON(json: any): Business {
    return BusinessFromJSONTyped(json, false);
}

export function BusinessFromJSONTyped(json: any, ignoreDiscriminator: boolean): Business {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'RESTAURANT') {
            return MerchantFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'type': BusinessTypeFromJSON(json['type']),
        'name': json['name'],
        'internalName': json['internalName'] == null ? undefined : json['internalName'],
        'taxonomies': json['taxonomies'] == null ? undefined : json['taxonomies'],
        'brands': json['brands'] == null ? undefined : json['brands'],
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(BusinessLabelFromJSON)),
        'icon': json['icon'] == null ? undefined : AssetFromJSON(json['icon']),
        'headerImage': json['headerImage'] == null ? undefined : AssetFromJSON(json['headerImage']),
        'parent': json['parent'] == null ? undefined : json['parent'],
        'stripeAccountId': json['stripeAccountId'] == null ? undefined : json['stripeAccountId'],
        'description': json['description'] == null ? undefined : json['description'],
        'address': AddressFromJSON(json['address']),
        'currency': json['currency'],
        'email': json['email'] == null ? undefined : json['email'],
        'distance': json['distance'] == null ? undefined : json['distance'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'suspendUntil': json['suspendUntil'] == null ? undefined : json['suspendUntil'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'website': json['website'] == null ? undefined : json['website'],
        'websiteMobile': json['websiteMobile'] == null ? undefined : json['websiteMobile'],
        'url': json['url'],
        'timeZone': json['timeZone'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'marketplacePercentageDelivery': json['marketplacePercentageDelivery'] == null ? undefined : json['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': json['marketplacePercentagePickup'] == null ? undefined : json['marketplacePercentagePickup'],
    };
}

export function BusinessToJSON(json: any): Business {
    return BusinessToJSONTyped(json, false);
}

export function BusinessToJSONTyped(value?: Business | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'RESTAURANT':
                return MerchantToJSONTyped(value as Merchant, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'type': BusinessTypeToJSON(value['type']),
        'name': value['name'],
        'internalName': value['internalName'],
        'taxonomies': value['taxonomies'],
        'brands': value['brands'],
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(BusinessLabelToJSON)),
        'icon': AssetToJSON(value['icon']),
        'headerImage': AssetToJSON(value['headerImage']),
        'parent': value['parent'],
        'stripeAccountId': value['stripeAccountId'],
        'description': value['description'],
        'address': AddressToJSON(value['address']),
        'currency': value['currency'],
        'email': value['email'],
        'distance': value['distance'],
        'isEnabled': value['isEnabled'],
        'isArchived': value['isArchived'],
        'suspendUntil': value['suspendUntil'],
        'isActive': value['isActive'],
        'website': value['website'],
        'websiteMobile': value['websiteMobile'],
        'url': value['url'],
        'timeZone': value['timeZone'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'marketplacePercentageDelivery': value['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': value['marketplacePercentagePickup'],
    };
}

